import { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import { setApps } from '../../../store/slices/master/appSlice';
import { IApps } from '../../../models/master/apps';
import { baseURL } from '../../../constants/commonConstants';
import { getApps } from '../../../action/masters/appActionCreator';
import { IResourceApps } from '../../../models/common/IResources';
import { UserRole } from '../../../constants/RoleEnum';
import { pageBlockId } from '../../../constants/pageBlocks';

const ResourceApps = (props: IResourceApps) => {
    const { getAllApps, apps, role } = props;
    const [show, setShow] = useState<number | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (apps && apps.length > 0) {
            setShow(apps[0].id);
        }
    }, [apps])

    useEffect(() => {
        switch (role) {
            case "Staff":
                getAllApps(pageBlockId.hrAndBenefits, undefined);
                break;
            case "Faculty":
                getAllApps(pageBlockId.facultyApps, undefined)
                break;
            case "Student":
                getAllApps(pageBlockId.studentApps, undefined)
                break;
            default:
                break;
        }

    }, [role]);

    useEffect(() => {
        return () => {
            dispatch(setApps([]));
        }
    }, []);


    const handleClickId = (id: number | null) => {
        setShow(id ?? 0);
    };

    return (
        <>
            <div className="card-wrap" id="studentapps">
                <div className="title">
                    <h2>{role} Apps</h2>
                </div>
                <div className="row">
                    <div className="col-lg-4">
                        <ul className="course-list apps-list">
                            {apps?.filter((app: IApps) => app.displayOrNot).map((app: IApps, index: number) => (
                                <li
                                    id="apps1"
                                    className={`${(show === app.id ? 'active' : '')}`}
                                    onClick={() => handleClickId(app.id)}
                                >
                                    <div className="img icon">
                                        <img src={baseURL + app.image} alt="" />
                                    </div>
                                    <div className="dtls">
                                        <h6>{app.name}</h6>
                                        <p>{app.description}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-lg-8 adaptheight">
                        <div className="row py-3 appsdtls apps1 show">
                            {apps && (() => {
                                const selectedApp = apps.find((app: IApps) => app.displayOrNot && app.id === show);
                                return selectedApp ? (
                                    <div className="col-lg-12" key={selectedApp.id}>
                                        <img
                                            src={baseURL + selectedApp.image}
                                            alt=""
                                            style={{ height: "50px" }}
                                            className="mb-3"
                                        />
                                        <h2 className="mb-2">{selectedApp.name}</h2>
                                        <p>{selectedApp.description}</p>
                                        <a href={selectedApp.url} target="_blank" rel="noopener noreferrer">
                                            <button className="btn btn-primary mt-3">Access App</button>
                                        </a>
                                    </div>
                                ) : null;
                            })()}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

const mapDispatchToProps = {
    getAllApps: (pageBlockId: number, noOfItems: number) =>
        getApps(undefined, pageBlockId, noOfItems),
};

function mapStateToProps(state: any) {
    return {
        apps: state.app.apps,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceApps);